module.exports = __webpack_public_path__ + "img/logo.4206de13.svg";